module.exports = __webpack_public_path__ + "img/rebuild_liao_pc3.9f5ea7ce.jpg";